import * as React from 'react';
import { ArticleHeading5, Body2 } from '@cian/ui-kit/typography';

import { ISuggestion } from '../../types';

import * as styles from './styles.css';

export interface ISuggestPopupProps {
  suggestions: ISuggestion[];
  notFoundText: string;

  onItemClick(value: ISuggestion): void;
}

export const SuggestPopup: React.FC<ISuggestPopupProps> = props => {
  const { suggestions, onItemClick, notFoundText } = props;

  return (
    <div className={styles['container']} data-testid="suggest-popup">
      {suggestions.map(item => {
        const onClick = () => onItemClick(item);

        return (
          <div key={item.name} className={styles['item']} onClick={onClick} data-testid="item">
            <Body2 display="inline">{item.displayName}</Body2>
          </div>
        );
      })}
      {!suggestions.length && (
        <div className={styles['error']} data-testid="error">
          <ArticleHeading5>Ничего не найдено</ArticleHeading5>
          <Body2 display="inline">{notFoundText}</Body2>
        </div>
      )}
    </div>
  );
};

SuggestPopup.displayName = 'SuggestPopup';
